import { useState } from 'react';
import { Path } from 'react-hook-form';
import { classNames, createLabelFor } from '../../../helpers/strings';

interface TextProps<T> {
  name: Path<T>;
  handleChange: (e: any) => void;
  autoComplete?: string;
  placeholder: string;
  value: any;
  type?: string;
  disabled?: boolean;
  required?: boolean;
  tooltip?: string;
}

export type TextInputI<T = any> = React.FC<TextProps<T>>;

export const GenericTextInput: TextInputI = ({
  name,
  handleChange,
  autoComplete = 'on',
  placeholder,
  value,
  type = "text",
  disabled = false,
  required = true,
  tooltip,
  ...props
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="sm:my-4">
      <label className="my-2 block text-sm font-medium text-gray-700">
        {createLabelFor(name)}
        {tooltip && (
          <span
            className="relative inline-block ml-1"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="inline h-4 w-4 text-gray-400 cursor-help" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            {showTooltip && (
              <span className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-1 w-64 p-2 text-xs font-normal text-white bg-gray-800 rounded shadow-lg">
                {tooltip}
              </span>
            )}
          </span>
        )}
      </label>
      <div className="flex flex-row items-center">
        <input
          name={name}
          type={type}
          autoComplete={autoComplete}
          placeholder={placeholder}
          value={value}
          required={required}
          disabled={disabled}
          {...props}
          onChange={handleChange}
          className={classNames(
            'block w-4/5 shadow-sm sm:text-sm rounded-md',
            disabled ? 'opacity-50 cursor-not-allowed' : ''
          )}
        />
        {required === false && (
          <span className="ml-4 italic text-gray-700 text-sm">Optional</span>
        )}
      </div>
    </div>
  );
};
